// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer__je7VZVlQ","innerContainer":"innerContainer__HTcaQa3e"};